export default "__VITE_ASSET__EyGNqR31__"